import { render, staticRenderFns } from "./iconClose.vue?vue&type=template&id=fe5c8d40&scoped=true"
import script from "./iconClose.vue?vue&type=script&lang=js"
export * from "./iconClose.vue?vue&type=script&lang=js"
import style0 from "./iconClose.vue?vue&type=style&index=0&id=fe5c8d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5c8d40",
  null
  
)

export default component.exports